import { useApp } from "@/contexts/AppContext";
import type {
  AnalyticsCampaignOption,
  AnalyticsCategoryOption,
  AnalyticsChannelOption,
} from "./types";

type AnalyticsAppContextValue = {
  campaigns: AnalyticsCampaignOption[];
  availableChannels: AnalyticsChannelOption[];
  availableCategories: AnalyticsCategoryOption[];
  availableTags: string[];
};

export const useAnalyticsApp = useApp as () => AnalyticsAppContextValue;
